import type InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import resetPresence from '../services/resetPresence';
import setPresence from '../services/setPresence';
import signInIM, { SignInType } from './signInIM';
import signOutIM from './signOutIM';

export default function dispatchPresenceUpdateFromHeader(
    currentPresence: InstantMessagePresenceType,
    newPresence: InstantMessagePresenceType
) {
    if (newPresence == 'Offline') {
        resetPresence();
        signOutIM();
    } else if (currentPresence == 'Offline') {
        signInIM(SignInType.Manual);
    } else {
        setPresence(newPresence);
    }
}
